/**
 * @generated SignedSource<<3afdbcdd23f87129101f7fe0014c14a6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useContentModeFragment_content$data = Result<{
  readonly contentProperties: {
    readonly draft?: {
      readonly contentMode: string | null;
    } | null;
    readonly latest?: {
      readonly contentMode: string | null;
    } | null;
  } | null;
  readonly id: string | null;
  readonly " $fragmentType": "useContentModeFragment_content";
}, unknown>;
export type useContentModeFragment_content$key = {
  readonly " $data"?: useContentModeFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useContentModeFragment_content">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "contentMode"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isLivePage"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useContentModeFragment_content",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "ContentProperties",
      "kind": "LinkedField",
      "name": "contentProperties",
      "plural": false,
      "selections": [
        {
          "condition": "isLivePage",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "concreteType": "PublishedContentProperties",
              "kind": "LinkedField",
              "name": "latest",
              "plural": false,
              "selections": (v0/*: any*/)
            }
          ]
        },
        {
          "condition": "isLivePage",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "concreteType": "DraftContentProperties",
              "kind": "LinkedField",
              "name": "draft",
              "plural": false,
              "selections": (v0/*: any*/)
            }
          ]
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "09f91bca2c7af89d06b97681af8d429b";

export default node;
